// Head.js
import React from 'react';
import { Helmet } from 'react-helmet';

const Head = ({ lang }) => {
  const metaTags = {
    en: {
      title: 'Temp Mail: Free Temporary Email - Disposable Email',
      description:
        'OneTimeInbox provides free, anonymous, and secure temporary email addresses. Avoid spam and protect your privacy with disposable emails for sign-ups and verifications. Try it now!',
      keywords:
        'temporary email, disposable email, free temp email, email generator, anonymous email, temporary inbox, one-time email, email privacy',
    },
    nl: {
      title: 'Tijdelijke E-mail: Gratis Wegwerp E-mail',
      description:
        'OneTimeInbox biedt gratis, anonieme en veilige tijdelijke e-mailadressen. Vermijd spam en bescherm je privacy met wegwerpe-mails voor aanmeldingen en verificaties. Probeer het nu!',
      keywords:
        'tijdelijke e-mail, wegwerp e-mail, gratis temp e-mail, e-mailgenerator, anonieme e-mail, tijdelijke inbox, eenmalige e-mail, e-mailprivacy',
    },
    de: {
      title: 'Temporäre E-Mail: Kostenlose Wegwerf-E-Mail',
      description:
        'OneTimeInbox bietet kostenlose, anonyme und sichere temporäre E-Mail-Adressen. Vermeiden Sie Spam und schützen Sie Ihre Privatsphäre mit Wegwerf-E-Mails für Anmeldungen und Verifizierungen. Probieren Sie es jetzt aus!',
      keywords:
        'temporäre E-Mail, Wegwerf-E-Mail, kostenlose Temp-E-Mail, E-Mail-Generator, anonyme E-Mail, temporäre Inbox, einmalige E-Mail, E-Mail-Datenschutz',
    },
    fr: {
      title: 'E-mail Temporaire: E-mail Jetable Gratuit',
      description:
        'OneTimeInbox fournit des adresses e-mail temporaires gratuites, anonymes et sécurisées. Évitez le spam et protégez votre vie privée avec des e-mails jetables pour les inscriptions et les vérifications. Essayez-le maintenant !',
      keywords:
        "e-mail temporaire, e-mail jetable, e-mail temp gratuit, générateur d'e-mail, e-mail anonyme, boîte de réception temporaire, e-mail à usage unique, confidentialité des e-mails",
    },
  };

  const { title, description, keywords } = metaTags[lang] || metaTags.en;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="alternate" href="https://onetimeinbox.com" hreflang="en" />
      <link rel="alternate" href="https://onetimeinbox.com/en" hreflang="en" />
      <link rel="alternate" href="https://onetimeinbox.com/nl" hreflang="nl" />
      <link rel="alternate" href="https://onetimeinbox.com/de" hreflang="de" />
      <link rel="alternate" href="https://onetimeinbox.com/fr" hreflang="fr" />
      <link rel="canonical" href="https://www.onetimeinbox.com/" />
    </Helmet>
  );
};

export default Head;
